import { render, staticRenderFns } from "./CustomerPrivacypolicy.vue?vue&type=template&id=22745fa7&scoped=true"
import script from "./CustomerPrivacypolicy.vue?vue&type=script&lang=js"
export * from "./CustomerPrivacypolicy.vue?vue&type=script&lang=js"
import style0 from "./CustomerPrivacypolicy.vue?vue&type=style&index=0&id=22745fa7&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22745fa7",
  null
  
)

export default component.exports